

export class ColumnsLayoutElement extends HTMLElement {
    private observer: ResizeObserver | undefined;

    get numberOfColumns() { return +(this.getAttribute('columns') || ''); }
    get minWidth() { return +(this.getAttribute('min-width') || ''); }
    items: Element[] = [];
    currentColumnsCount: number = 0;

    connectedCallback() {
        const $element = this;

        this.items = [...$element.children as any] as Element[];

        this.render();

        this.observer = new ResizeObserver((entries: ResizeObserverEntry[]) => this.render(entries[0].contentRect.width));
        this.observer.observe($element);
    }

    render(width?: number) {
        const $element = this;

        const elementWidth = width ?? $element.getBoundingClientRect().width;
        const minCount = Math.trunc(elementWidth / this.minWidth);
        const columnsCount = Math.max(1, Math.min(this.numberOfColumns, minCount));

        if (this.currentColumnsCount != columnsCount) {
            this.currentColumnsCount = columnsCount;

            $element.style.display = 'grid';
            $element.style.gridTemplateColumns = `repeat(${columnsCount}, 1fr)`;
            $element.style.gap = this.getAttribute('gap') || '';

            const columns = new Array(columnsCount).fill(0).map(() => {
                const column = document.createElement('div');
                column.className = `column`;
                return column;
            });

            let count = 0;
            for (const child of this.items) {
                const column = columns[count++ % columnsCount];
                column.append(child);
            }

            while ($element.firstChild) $element.removeChild($element.lastChild!);

            $element.append(...columns);
        }
    }

    disconnectedCallback() {
        this.observer?.disconnect();
    }
}

customElements.define('columns-layout', ColumnsLayoutElement);
